<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 16:03:52
-->
<template>
  <div>
    <!-- <div>
      <div>当前uuid:{{ staffuuid }}</div>
      <mrc_ess_chooseStaff v-model="staffuuid"> </mrc_ess_chooseStaff>
    </div> -->
    <mrc_ess_table
      v-if="$route.name == 'staffGroup'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-staff-group')"
      pageName="addStaffGroup"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['organization_info', 'groupName']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.groupName="{item}">
        {{ INT(item.groupName) }}
      </template>

      <template v-slot:item.organization_info="{ item }">
        <mrc_ess_chip
          class="mr-1 my-1"
          v-for="item1 in item.organization_info"
          :key="item1.uuid"
          small
        >
          {{ INT(item1.organization_names) }}
        </mrc_ess_chip>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon>mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getStaffCompanyGroupList,
  addCompanyGroup,
  detailCompanyGroup,
  deleteCompanyGroup,
} from "@/service/api/staffmsg.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      staffuuid: "",
      stepIndex: 1,
      dialog: false,
      disabled: true,
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],

      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    stepList() {
      return [
        {
          name: this.$t("label_Importing_files"),
        },
        {
          name: this.$t("label_result"),
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-group"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-group"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-staff-group"),
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_groupName"),
          align: "start",
          value: "groupName",
          sortable: false,
        },
        {
          text: this.$t("label_member"),
          value: "organization_info",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "staffGroup") {
        this.getlist()
      }
    },
  },
  beforeDestroy() {},
  async mounted() {
    await this.getlist()
  },

  methods: {
    changeIndex(v) {
      if (v == 0) {
        this.dialog = false
      } else if (v == 3) {
        //提交代码逻辑
      } else {
        this.stepIndex = v
      }
    },
    async getlist(obj) {
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.params = Object.assign({}, this.params, obj)
      }
      this.loading = true
      let res = await getStaffCompanyGroupList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        company_uuid: this.$store.state.currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        if (!Array.isArray(res.data)) {
          res = res.data
          this.desserts = res.data
          this.options.totalcount = res.totalcount
          this.options.totalpage = res.totalpage
          this.systemFieldMeta = res.systemFieldMeta
          this.field_alias_name = res.field_alias_name
          this.table_alias_name = res.table_alias_name
        } else {
          this.desserts = res.data
          this.options.totalcount = res.totalcount
          this.options.totalpage = res.totalpage
          this.systemFieldMeta = res.systemFieldMeta
          this.field_alias_name = res.field_alias_name
          this.table_alias_name = res.table_alias_name
        }
      }
      this.loading = false
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.groupName)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailStaffGroup",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.groupName)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailStaffGroup",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteCompanyGroup({ uuids: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() {},
    cancel() {},
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
